import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants, FILE_UPLOAD_TIMEOUT, generateRandomString } from 'src/app/constants';
import { DashboardService } from 'src/app/services/dashboard.service';
import { CommonConstant } from '../../constant/common.constant';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import * as FileSaver from 'file-saver-es';
import { DeletePopupComponent } from '../delete-popup/delete-popup.component';
import { Router } from '@angular/router';
import { AetStateService } from 'src/app/services/aet-state.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WebSocketService } from 'src/app/services/websocket.service';
import { environment } from 'src/environments/environment';
import { catchError, EMPTY, takeWhile, timeout } from 'rxjs';


@Component({
  selector: 'app-edit-event',
  templateUrl: './edit-event.component.html',
  styleUrls: ['./edit-event.component.scss'],
  standalone: false // NOSONAR
})

export class EditEventComponent implements OnInit {
  maxi: any = 1000;
  ldiv: any = 0;
  comments: any;
  toyotaGUID: string;
  upn: string;
  successMessage: any;
  errorMessage: any;
  fileName = '';
  statusList: any[] = [];
  logisticList: any[] = [];
  eventProbTypeList: any[] = [];
  editEventForm: FormGroup;
  submitted: boolean;
  eventList: any[] = [];
  eventId: String;
  apiResponse: any;
  plannedUnload: any;
  eventType: any;
  status: any;
  commentsField: number = 1000;
  route: any;
  trailer: any;
  lastUpdated: any;
  incidentDateTime;
  arrivalDate;
  arrivalTime;
  incidentDate;
  incidentTime;
  errormsg: any;
  res: any;
  defaultLP: any;
  eventTypes: any;
  upload: boolean = false;
  fetchedDocs: any = [];
  dltRes: any;
  responseOnLoad: any;
  logisticPartnerList: any[] = [];
  problemTypeList: any;
  eventProblemMapping: any;
  filterResponse: any = [];
  problemType: any;
  defaultEvent: any;
  defaultStatus: any;
  defaultProbType: any;
  statusId: any;
  isAccessible: boolean = true
  isDeleteAccessible: boolean = true
  orderNumber: any[] = [];
  impactedOrderNumber: any[] = [];
  filteredOrderNumber: any[] = [];
  impactedOrderSearchCtrl: FormControl<string | null> = new FormControl('');
  selectedFileName: any;
  selectedFilePath: any;


  constructor(
    private readonly dashboardService: DashboardService,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly dialog: MatDialog,
    public dialogRef: MatDialogRef<EditEventComponent>,
    private readonly formBuilder: FormBuilder,
    public constants: Constants,
    private readonly router: Router,
    private readonly DatePipe: DatePipe,
    private readonly aetStateService: AetStateService,
    private readonly webSocketService: WebSocketService
  ) { }

  ngOnInit(): void {
    // this.checkRoles();
    this.submitted = false;
    this.toyotaGUID = '';
    this.toyotaGUID = localStorage.getItem('toyotaGUID');
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    this.upn= fgaDetails?.user?.userPrincipalName;
    this.eventId = '';
    if (localStorage.getItem('eventId')) {
      this.eventId = localStorage.getItem('eventId');
    }
    this.createForm();
    this.impactedOrderSearchCtrl.valueChanges.subscribe((value) =>
      this.filterImpactedOrders(value)
    );
    this.addEventDataLoad();
    this.fetchApi();
  }

  async checkRoles() {
    await this.aetStateService.getRoles();
    const roles = this.aetStateService.getroleState();
    const userRoles = JSON?.parse(roles);
    if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
      userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
      userRoles.includes(this.constants.LIOS_UAC_AET_LP)) {
      // ||userRoles.includes(this.constants.LIOS_UAC_MTMUS_Negotiator)||userRoles.includes(this.constants.LIOS_UAC_Portal_Administrator)
      // ||userRoles.includes(this.constants.LIOS_UAC_Reporting_Admin)||userRoles.includes(this.constants.LIOS_UAC_Reporting_User)
      // ||userRoles.includes(this.constants.LIOS_UAC_Route_Planner)||userRoles.includes(this.constants.LIOS_UAC_SCV_Admin)
      // ||userRoles.includes(this.constants.LIOS_UAC_Security_Admin)||userRoles.includes(this.constants.LIOS_UAC_TEMA_AF)
      // ||userRoles.includes(this.constants.	public LIOS_UAC_TEMA_Budgeting))||userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_AM)
      // ||userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_Specialist)||userRoles.includes(this.constants.LIOS_UAC_TEMA_Purchasing)
      // ||userRoles.includes(this.constants.LIOS_UAC_TEMA_LC)||userRoles.includes(this.constants.LIOS_UAC_TPT_Admin)
      // ||userRoles.includes(this.constants.LIOS_UAC_TSCS_Admin)||userRoles.includes(this.constants.LIOS_UAC_WT_Administrator)
      if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) ||
        userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
        userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner)) {
        // ||userRoles.includes(this.constants.LIOS_UAC_MTMUS_Negotiator)||userRoles.includes(this.constants.LIOS_UAC_Portal_Administrator)
        // ||userRoles.includes(this.constants.LIOS_UAC_Reporting_Admin)||userRoles.includes(this.constants.LIOS_UAC_Reporting_User)
        // ||userRoles.includes(this.constants.LIOS_UAC_Route_Planner)||userRoles.includes(this.constants.LIOS_UAC_SCV_Admin)
        // ||userRoles.includes(this.constants.LIOS_UAC_Security_Admin)||userRoles.includes(this.constants.LIOS_UAC_TEMA_AF)
        // ||userRoles.includes(this.constants.	public LIOS_UAC_TEMA_Budgeting))||userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_AM)
        // ||userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_Specialist)||userRoles.includes(this.constants.LIOS_UAC_TEMA_Purchasing)
        // ||userRoles.includes(this.constants.LIOS_UAC_TEMA_LC)||userRoles.includes(this.constants.LIOS_UAC_TPT_Admin)
        // ||userRoles.includes(this.constants.LIOS_UAC_TSCS_Admin)||userRoles.includes(this.constants.LIOS_UAC_WT_Administrator)
        this.isDeleteAccessible = true;
      }
      this.isAccessible = true;
    }
    else {
      this.router.navigate([`/home`]);
    }
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
    //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
    //   // this.isAccessible = true;
    // } else {
    //   this.router.navigate([`/home`]);
    // }
  }

  get form() {
    return this.editEventForm.controls;
  }

  createForm() {
    this.editEventForm = this.formBuilder.group({
      eventType: ['', [Validators.required]],
      plannedUnload: [''],
      route: [''],
      status: ['', [Validators.required]],
      problemType: ['', [Validators.required]],
      logisticPartner: [''],
      incidentDate: [''],
      incidentTime: [''],
      trailer: [''],
      comments: [''],
      lastUpdated: [''],
      impactedOrderNumber: [this.impactedOrderNumber]
    });
  }


  apiCall() {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.dashboardService.editOnLoad(this.eventId)?.subscribe((response) => { // NOSONAR
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      this.apiResponse = response;
      for (const i in this.responseOnLoad.eventTypes) {
        if (this.apiResponse.eventTypeId == this.responseOnLoad.eventTypes[i].eventTypeId) {   // NOSONAR
          this.defaultEvent = this.responseOnLoad.eventTypes[i].description;
        }
      }
      this.form['eventType'].setValue(this.eventProbTypeList.find((x) => x.eventType == this.defaultEvent));   // NOSONAR
      this.plannedUnload = this.dateFormatter(this.apiResponse.arrival);
      this.arrivalDate = this.incidentDateFormatter(this.apiResponse.arrival);
      this.arrivalTime = this.incidentTimeFormatter(this.apiResponse.arrival);
      this.route = this.apiResponse.puRoute;
      for (const i in this.responseOnLoad.eventStatuses) {
        if (this.apiResponse.statusId == this.responseOnLoad.eventStatuses[i].statusId) {   // NOSONAR
          this.defaultStatus = this.responseOnLoad.eventStatuses[i].description;
        } else {
          // do nothing
         }
      }
      this.form['status'].setValue(this.statusList.find((x) => x.description == this.defaultStatus));   // NOSONAR
      for (const i in this.responseOnLoad.problemTypes) {
        if (this.apiResponse.problemTypeId == this.responseOnLoad.problemTypes[i].problemTypeId) {   // NOSONAR
          this.defaultProbType = this.responseOnLoad.problemTypes[i].description;
        }
      }
      for (const i in this.eventProbTypeList) { // NOSONAR
        const filterArr = this.eventProbTypeList[i].problemTypes.find((x) => x.description == this.defaultProbType)   // NOSONAR
        if (filterArr != undefined) {  // NOSONAR
          this.form['problemType'].setValue(filterArr);
          break;
        }
      }
      for (const i in this.responseOnLoad.logisticsPartners) {
        if (this.apiResponse.transportationProviderId == this.responseOnLoad.logisticsPartners[i].vendorId) {   // NOSONAR
          this.defaultLP = this.responseOnLoad.logisticsPartners[i].shortName;
        }
      }
      this.form['logisticPartner'].setValue(this.logisticPartnerList.find((x) => x.shortName == this.defaultLP)?.vendorId)   // NOSONAR
      this.trailer = this.apiResponse.eventTrailer;
      this.comments = this.apiResponse.comments;
      if (this.comments == null || this.comments == undefined) {   // NOSONAR
        this.ldiv = 0;
      }
      else {
        this.ldiv = this.comments.length;
      }
      this.incidentDateTime = this.apiResponse.eta;
      this.incidentDate = this.incidentDateFormatter(this.incidentDateTime);
      this.incidentTime = this.incidentTimeFormatter(this.incidentDateTime);
      this.lastUpdated = this.dateFormatter(this.apiResponse.lastUpdated);

      this.orderNumber = [];
      (this.apiResponse.allOrders || []).forEach((element) => {
        const normalizedOrder = String(element ?? '').trim();
        if (normalizedOrder) {
          this.orderNumber.push({ description: normalizedOrder, code: normalizedOrder });
        }
      });
      this.filteredOrderNumber = [...this.orderNumber];

      const impactedOrders = (this.apiResponse.impactedOrderNumber || [])
        .map((element) => String(element ?? '').trim())
        .filter((element) => !!element);

      this.impactedOrderNumber = this.orderNumber.filter((order) =>
        impactedOrders.includes(order.code)
      );

      this.form['impactedOrderNumber'].setValue(this.impactedOrderNumber);

      this.onEventTypeSelection();
    }, (err) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      console.info(err);
    });

  }

  fetchApi() {
    this.dashboardService.fetchDocs(this.eventId)?.subscribe((response) => {
      this.fetchedDocs = response;
    }, (err) => {
      console.info(err);
    });
  }

  download(imgId, fileName) {
    this.dashboardService.downloadDocs(this.eventId, imgId)?.subscribe((response) => {
      const filename = fileName;
      const data: Blob = new Blob([(<any>response)?.body],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/jpeg,application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      FileSaver.saveAs(data, filename);
    }, (err) => {
      console.info(err);
    });
  }

  delete(imgId) {
    this.dashboardService.deleteDocs(this.eventId, imgId)?.subscribe((response) => {
      this.dltRes = response;
      if (this.dltRes == "Successfully deleted the document") {   // NOSONAR
        this.successMessage = 'File deleted successfully';
        this.fetchApi();
      } else {
        this.errorMessage = 'File not deleted';
      }
    }, (err) => {
      console.info(err);
    });
  }

  closeNotif() {
    this.errorMessage = null;
    this.successMessage = null;
  }

  btnHandler() {
    this.dialogRef.close({ event: 'onDeletePress', id: this.eventId });
  }

  openDelete() {
    this.dialog?.open(DeletePopupComponent, {
      data: {
        eventId: this.eventId,
        toyotaGUID: this.toyotaGUID
      },
      width: '540px',
      // height: '290px'
    },)
    this.close();
  }

  close(): void {
    this.dialogRef.close({ event: 'CloseEvent' });
  }

  checkChange(value: string) {
    this.ldiv = value.length;
  }

  dateFormatter(res) {
    return res ? moment(res).format('MM/DD/YYYY HH:mm') : null;
  }

  incidentDateFormatter(res) {
    return res ? moment(res).format('yyyy-MM-DD') : null;
  }

  incidentTimeFormatter(res) {
    return res ? moment(this.incidentDateTime).format('HH:mm') : null;
  }

  onDateSelection() {
    this.form['incidentTime'].setValue(moment(new Date()).format('HH:mm'));
  }

  onSubmit(): void {
    this.submitted = true;
    this.errormsg = '';
    if (this.editEventForm.valid) {
      this.onCreateAPI();
    }
  }
  onCreateAPI() {
    if (
      this.incidentTime != null  // NOSONAR
    ) {
      if ( this.incidentDate == '' || this.incidentDate == null ) {   // NOSONAR
        this.errorMessage = 'Please select the ETA Date';
      }
      else {

        this.submitApi();
      }
    } else {

      this.submitApi();
    }
  }

  submitApi() {
    const normalizedImpactedOrders = this.getNormalizedImpactedOrders();

    const updateObject = {
      eventId: this.eventId,
      eventTypeId: this.form['eventType'].value.eventTypeId,
      arrival: `${this.DatePipe.transform(this.arrivalDate, 'MM-dd-yyyy')}${' '}${this.arrivalTime}${':00'}`,
      puRoute: this.apiResponse.puRoute,
      statusId: this.form['status'].value.statusId,
      problemTypeId: this.form['problemType'].value.problemTypeId,
      transportationProviderId: this.form['logisticPartner'].value,
      eta: this.incidentDate ? `${this.DatePipe.transform(this.incidentDate, 'MM-dd-yyyy')}${' '}${this.incidentTime}${':00'}` : '',
      eventTrailer: this.trailer,
      comments: this.comments,
      impactedOrderNumber: normalizedImpactedOrders,
      // lastUpdated:`${this.incidentDate}${'T'}${this.incidentTime}${':00Z'}`
    };

    this.dashboardService
      .updateEvent(updateObject, this.upn)
      .subscribe(
        (response) => {
          const newRes = response.toString();
          if (newRes.toLowerCase() == 'success') {   // NOSONAR
            this.dialogRef.close({
              event: 'SaveEvent',
              responseType: 'success'
            });
            // changes goes here...
            const currentUrl = this.router.url
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate([currentUrl]);
            });
          } else {
            console.info('error')
          }
        },
        (error) => {
          console.info(error)
        }
      );
  }

  private getNormalizedImpactedOrders(): string[] {
    const selectedOrders = this.form['impactedOrderNumber']?.value;
    if (!Array.isArray(selectedOrders)) {
      return [];
    }

    return selectedOrders
      .map((item: any) => {
        if (typeof item == 'string') { // NOSONAR
          return item;
        }
        return item?.description ?? item?.code ?? '';
      })
      .map((value) => String(value ?? '').trim())
      .filter((value) => !!value);
  }

  onImpactedOrderPanelToggle(isOpen: boolean): void {
    if (!isOpen) {
      this.impactedOrderSearchCtrl.setValue('', { emitEvent: false });
      this.filteredOrderNumber = [...this.orderNumber];
    }
  }

  private filterImpactedOrders(searchText: string | null): void {
    const normalizedSearch = String(searchText ?? '').trim().toLowerCase();

    if (!normalizedSearch) {
      this.filteredOrderNumber = [...this.orderNumber];
      return;
    }

    this.filteredOrderNumber = this.orderNumber.filter((order) => {
      const label = String(order?.description ?? order?.code ?? '').toLowerCase();
      return label.includes(normalizedSearch);
    });
  }

  addEventDataLoad() {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.dashboardService.getAddEventData()?.subscribe(
      (response) => {
        this.filterResponse = response;
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        if (response) {
          this.responseOnLoad = response;
          this.logisticPartnerList = this.responseOnLoad.logisticsPartners;
          this.logisticPartnerList = [...this.logisticPartnerList].sort((a, b) => {
            const descA = a.vendorName?.toLowerCase() ?? '';
            const descB = b.vendorName?.toLowerCase() ?? '';

            return descA.localeCompare(descB);
          });
          this.statusList = this.responseOnLoad.eventStatuses;
          this.statusList = [...this.statusList].sort((a, b) => {
            const descA = a.description?.toLowerCase() ?? '';
            const descB = b.description?.toLowerCase() ?? '';

            return descA.localeCompare(descB);
          });
          this.eventTypes = this.responseOnLoad.eventTypes;
          this.eventTypes = [...this.eventTypes].sort((a, b) => {
            const descA = a.description?.toLowerCase() ?? '';
            const descB = b.description?.toLowerCase() ?? '';

            if (descA == 'other') {return 1;}   // NOSONAR
            if (descB == 'other') {return -1;}   // NOSONAR

            return descA.localeCompare(descB);
          });


          this.problemTypeList = this.responseOnLoad.problemTypes;
          this.eventProblemMapping =
            this.responseOnLoad.eventProblemMappings;
          this.eventTypes.forEach((element) => {
            const mapping = {
              eventTypeId: element.eventTypeId,
              eventType: element.description,
              problemTypes: [],
            };
            const problemIds = this.eventProblemMapping.filter(
              (value: any) => value.eventTypeId == element.eventTypeId   // NOSONAR
            ); const problems = [];
            problemIds.forEach((element2) => {
              const id = element2.problemTypeId;
              const type = this.problemTypeList.find(
                (value) => value.problemTypeId == id   // NOSONAR
              );
              if (type != undefined) {  // NOSONAR
                problems.push(type);
              }
            });
            mapping.problemTypes = problems;
            this.eventProbTypeList.push(mapping);
          });
        }
        this.apiCall()
      },
      (err) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        console.info(err);
        this.errorMessage = this.constants.APIErrorMessage;
      }
    );
  }
  onEventTypeSelection() {
    this.eventList = [];
    const eventTypId = this.form['eventType'].value.eventTypeId;
    for (let i = 0; i < this.eventProbTypeList.length; i++) {
      if (this.eventProbTypeList[i].eventTypeId == eventTypId) {   // NOSONAR
        for (
          let j = 0;
          j < this.eventProbTypeList[i].problemTypes.length;
          j++
        ) {
          this.eventList.push(this.eventProbTypeList[i].problemTypes[j]);
          this.eventList = [...this.eventList].sort((a, b) => {
            const descA = a.description?.toLowerCase() ?? '';
            const descB = b.description?.toLowerCase() ?? '';

            return descA.localeCompare(descB);
          });

        }
        break;
      }
    }
  }

  emptyValidation() {
    this.form['problemType'].patchValue("");
  }

  createValidations() {
    let returnVal = true;
    if (this.editEventForm.invalid) {
      returnVal = false;
    }
    return returnVal;
  }

  msg1 = 'File is not uploaded...please try again'
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    this.fileName = file.name;
    this.upload = false;
    const extension = this.fileName.substring(this.fileName.lastIndexOf('.'));
    if (extension.toLowerCase() == '.xlsx' || extension.toLowerCase() == '.pdf' || extension.toLowerCase() == '.jpeg' || extension.toLowerCase() == '.docx'    // NOSONAR
      || extension.toLowerCase() == '.xls' || extension.toLowerCase() == '.jpg' || extension.toLowerCase() == '.doc' || extension.toLowerCase() == '.png' ||     // NOSONAR
      extension.toLowerCase() == '.svg') {    // NOSONAR
      this.dashboardService.uploadFile(file, this.eventId).subscribe((response) => {
        this.res = response;
        if (this.res.status == 200) {    // NOSONAR
          this.upload = true;
          this.fetchApi();
        }
        else {
          this.upload = false;
          this.errorMessage = this.msg1;

        }
      })
    } else {
      this.upload = false;
      this.errorMessage = 'Can accept only .xlsx,.pdf,.jpeg and .docx files';
    }
  }

  async newonFileSelected(event: any) {
    const file: File = event.target.files[0];
    this.fileName = file.name;
    this.upload = false;
    const extension = this.fileName.substring(this.fileName.lastIndexOf('.'));
    if (extension.toLowerCase() == '.xlsx' || extension.toLowerCase() == '.pdf' || extension.toLowerCase() == '.jpeg' || extension.toLowerCase() == '.docx'     // NOSONAR
      || extension.toLowerCase() == '.xls' || extension.toLowerCase() == '.jpg' || extension.toLowerCase() == '.doc' || extension.toLowerCase() == '.png' ||      // NOSONAR
      extension.toLowerCase() == '.svg') {    // NOSONAR
      const parsedFileName = this.fileName
        ?.replace(/\s+/g, '_') // Replace spaces with underscore
        ?.replace(/[^a-zA-Z0-9._]/g, '_'); // Replace all non-alphanumeric/safe characters with underscore
      this.selectedFileName = `${generateRandomString()}_${parsedFileName}`;
      this.selectedFilePath = `AET/UploadDocummnet/${this.selectedFileName}`;
      try {
        this.webSocketService.connect();
        await this.webSocketService.waitUntilSocketConnected();
        console.info(
          'WebSocket connected:',
          this.webSocketService.isSocketConnected()
        );
        this.webSocketService.sendMessage(
          // JSON.stringify({
          { fileName: this.selectedFilePath }
          // })
        );
        const url = `${environment.FILE_UPLOAD_URI}/${this.selectedFilePath}`;
        const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
        const upn = fgaDetails?.user?.userPrincipalName;

        const uploadHeaders: any = {
          'Content-Type': file?.type, // Set file content type
          'x-auth-token': sessionStorage.getItem('accessToken'),
          'x-amz-meta-userid': upn

        };

        const response = await fetch(url, {
          method: 'PUT',
          headers: uploadHeaders,
          body: file,
        });

        if (!response.ok) {
          this.errorMessage = 'Failed to upload file!'
          this.webSocketService.closeConnection();
          return;
        }

        this.webSocketService
          .receiveMessages()
          .pipe(
            // If no message is received within 25 seconds, throw TimeoutError
            timeout({
              each: FILE_UPLOAD_TIMEOUT, // 25 seconds between messages
            }),
            takeWhile( (msg) => msg.status != 'success' && msg.status != 'failed' && msg.status != 'error', true ), // NOSONAR
            catchError((err) => {
              if (err.name == 'TimeoutError') {   // NOSONAR
                console.info(
                  `No message received in ${FILE_UPLOAD_TIMEOUT / 1000
                  } seconds. Closing connection.`
                );
                this.ngxUiLoaderService.stop(CommonConstant.loader);
                this.webSocketService.closeConnection();
                this.errorMessage = 'Failed to upload file. Please re-upload the file.'
              } else {
                console.info('WebSocket error:', err);
              }
              return EMPTY; // Stop further emissions
            })
          )
          .subscribe((messages: any) => {
            console.info(messages, "messages from Lambda");

            const backendResp = messages.backendResponse;
            try {
              if (backendResp) {
                // Check backend API response for success/failure
                this.res = backendResp;
                if (this.res.status == 200) {   // NOSONAR
                  this.upload = true;
                  this.fetchApi();
                }
                else {
                  this.upload = false;
                  this.errorMessage = this.msg1;

                }

              }
            }
            catch {
              this.upload = false;
              this.errorMessage = this.msg1;
            }
            this.ngxUiLoaderService.stop(CommonConstant.loader);
            this.webSocketService.closeConnection();
          })
      } catch (err) {
        this.upload = false;
        console.info('Unexpected upload exception:', err);
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.webSocketService.closeConnection();
        this.errorMessage = 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists'
      }
    } else {
      this.upload = false;
      this.errorMessage = 'Can accept only .xlsx,.pdf,.jpeg and .docx files';
    }
  }

}

